import { render } from "./WebhookFiltersTab.vue?vue&type=template&id=1cf8060b&scoped=true"
import script from "./WebhookFiltersTab.vue?vue&type=script&lang=js"
export * from "./WebhookFiltersTab.vue?vue&type=script&lang=js"

import "./WebhookFiltersTab.vue?vue&type=style&index=0&id=1cf8060b&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf8060b"]])

export default __exports__